<template>
  <SfModalPortal
    :modal-id="'enable-market-package-firm-confirmation-modal'"
    :size="'xs'"
    @opened="handleOpened"
  >
    <template #title>
      {{ props.title }}
    </template>
    <template #body>
      <div v-dompurify-html="bodyPara1" class="tw-pb-6"></div>
      <div v-for="name in selectedContentNames" :key="name" class="tw-pl-2">
        <ul>
          <li>
            <b>{{ name }}</b>
          </li>
        </ul>
      </div>
      <div v-dompurify-html="bodyPara2" class="tw-pt-6"></div>
      <div v-dompurify-html="bodyPara3" class="tw-pt-4"></div>
    </template>
    <template #messages-bottom>
      <SfModalMessage v-if="message" :variant="messageVariant">
        {{ message }}
      </SfModalMessage>
    </template>
    <template #footer>
      <SfButton variant="danger" @click="handleSuccess">
        {{ successButtonText }}
      </SfButton>
      <SfButton variant="info" @click="handleCancel">Cancel</SfButton>
    </template>
  </SfModalPortal>
</template>

<script lang="ts" setup>
import {
  SfModalPortal,
  SfModalMessage,
} from '@app/shared/vue/components/sf-modal'
import { SfButton } from '@app/shared/vue/components/sf-button'
import type { MessageType } from '@app/shared/vue/components/sf-modal/constants'
import type { ModalPortalPayloadMap } from '@app/types'
import { ref } from 'vue'

interface Props {
  title: string
  messageVariant: MessageType
  message: string
  successButtonText: string
}
const I18n = window.I18n
const props = defineProps<Props>()

const marketPackageNames = ref<Array<string>>([])
const companiesCount = ref('')
const formElement = ref<HTMLFormElement | null>(null)
const isTriggerCompanyTemplate = ref<boolean>(false)
const selectedContentNames = ref<Array<string>>([])
const bodyPara1 = ref('')
const bodyPara2 = ref('')
const bodyPara3 = ref('')

const handleOpened = (
  payload: ModalPortalPayloadMap['enable-market-package-firm-confirmation-modal']
) => {
  companiesCount.value = payload.companiesCount || '0'
  formElement.value = payload.formElement || null
  marketPackageNames.value = payload.marketPackageNames
  isTriggerCompanyTemplate.value = payload.isTriggerCompanyTemplate
  selectedContentNames.value = payload.selectedContentNames

  if (isTriggerCompanyTemplate.value) {
    if (companiesCount.value === '0') {
      bodyPara1.value = I18n.t(
        'market_packages.firm_company_template.activation_modal.no_company_usage_body'
      )
    } else {
      bodyPara1.value = I18n.t(
        'market_packages.firm_company_template.activation_modal.company_usage_body',
        {
          companies_count: companiesCount.value,
        }
      )
    }
    if (marketPackageNames.value && marketPackageNames.value.length > 0) {
      bodyPara3.value = I18n.t(
        'market_packages.firm_company_template.activation_modal.body_message'
      )
    } else {
      bodyPara3.value = ''
    }
  } else {
    if (companiesCount.value === '0') {
      bodyPara1.value = I18n.t(
        'market_packages.firm_template.activation_modal.no_company_usage_body'
      )
    } else {
      bodyPara1.value = I18n.t(
        'market_packages.firm_template.activation_modal.company_usage_body',
        { companies_count: companiesCount.value }
      )
    }
    bodyPara2.value = I18n.t(
      'market_packages.firm_template.activation_modal.body_para_1'
    )

    if (marketPackageNames.value && marketPackageNames.value.length > 0) {
      bodyPara3.value = I18n.t(
        'market_packages.firm_template.activation_modal.body_para_2'
      )
    } else {
      bodyPara3.value = ''
    }
  }
}

const handleCancel = () => {
  window.modalCitizen.closeModalPortal()
}

const handleSuccess = () => {
  window.modalCitizen.closeModalPortal()

  if (formElement.value) {
    formElement.value.submit()
    return
  }
}
</script>
